module.exports = __webpack_public_path__ + "static/media/universal-studio-japan-2.4f432fb7.jpg";